// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"5b1cd72d","903":"9fcc1539"}[chunkId] + ".chunk.js";
};